






























import { Component, Vue } from 'vue-property-decorator';
import { attachmentApis, MailAttachment } from '@/api/attachments.api';
import { formatterDatetime } from '@/common';

@Component
export default class CopyAttachmentShardDialog extends Vue {
  dialogVisible = false;
  loading = false;
  sharedLink = '';
  fileName = '';
  shareHtml = '';
  attachment = {} as MailAttachment;

  async show(attachment: MailAttachment) {
    this.attachment = attachment;
    this.dialogVisible = true;
    this.fileName = attachment.filename || '附件';
    this.loading = true;
    this.sharedLink = '';
    this.shareHtml = '';

    try {
      const response = await attachmentApis.sharedAttachment(attachment.uid);
      this.sharedLink = response.link;
      this.shareHtml = response.html;
    } catch (error) {
      this.$message.error(`生成共享链接失败: ${error.message || error}`);
    } finally {
      this.loading = false;
    }
  }

  get alertTitle() {
    let msg = '您可以粘贴到邮件中发送给他人。';
    if (this.attachment.expire_at) {
      msg += ` 有效期截止 ${formatterDatetime(this.attachment.expire_at)}`;
    }
    return msg;
  }

  copyToClipboard(content: string) {
    const input = document.createElement('textarea');
    input.value = content;
    document.body.appendChild(input);
    input.select();

    try {
      document.execCommand('copy');
      this.$message.success('已复制到剪贴板');
    } catch (error) {
      this.$message.error('复制失败，请手动复制');
    } finally {
      document.body.removeChild(input);
    }
  }
}
